// extracted by mini-css-extract-plugin
module.exports = {"skeletonLabel":"TableSkeleton_skeletonLabel__3Wvvr","skeletonCell":"TableSkeleton_skeletonCell__2-R76","shimmer":"TableSkeleton_shimmer__11m_U"};